export default "__VITE_ASSET__BnVJGPJl__"